// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"9b023cdc","282":"649984a0","303":"5df05bf1","358":"36632d98","563":"149a71bd","584":"0f65a0c2","765":"b0fcee5a","925":"8eba7d3f","944":"3399ae8f","960":"c31ac362"}[chunkId] + ".chunk.js";
};